
import {CatalogProductOverviewRestDto, ProductDiscountRestDto} from "@/api/pharma-cpc-product-mgmt/models";
import {ProductInfoRestDtoModel} from "@/models/api/pharma-cpc-mgmt/ProductInfoRestDtoModel";
import {ProductPriceRestDtoModel} from "@/models/api/pharma-cpc-mgmt/ProductPriceRestDtoModel";

export class CatalogProductOverviewRestDtoModel implements CatalogProductOverviewRestDto {
    main_image_url?: string | null;
    discount?: ProductDiscountRestDto | null;
    product_code: string;
    product_code_alias: number;
    product_source_code: string;
    product_info: ProductInfoRestDtoModel;
    product_price: ProductPriceRestDtoModel;
    customer_product_sort_weight?: number | null;

    constructor() {
        this.product_code = '';
        this.product_code_alias = -1;
        this.product_source_code = '';
        this.product_info = ProductInfoRestDtoModel.createWithDefaults();
        this.product_price = ProductPriceRestDtoModel.createWithDefaults();
    }

    public static createWithDefaults(): CatalogProductOverviewRestDtoModel {
        return new this();
    }
}
